import { WidgetComponent } from '@juvare/widget-ui/WidgetComponent';
import { WidgetEditorContext } from '@juvare/widget-ui/WidgetEditorContext';
import { Box } from '@mui/material';
import React from 'react';
import { DragTargetPlaceholder } from '../../WidgetForm/Components';
import { getChildWidgetStyle, getVisibleError } from '../../WidgetForm/Utils';
import { DropTargetSpacerHorizontal } from './DropTargetSpacerHorizontal';
export const BaseLayoutColumn = (props) => {
    var _a;
    const editorContext = React.useContext(WidgetEditorContext);
    let childProps = props.childProps;
    if (!editorContext.editMode) {
        childProps = childProps.filter((p) => !p.hidden);
    }
    let commonChildStyle = undefined;
    switch (props.horizontalAlign) {
        case 'left':
            commonChildStyle = { marginRight: 'auto' };
            break;
        case 'right':
            commonChildStyle = { marginLeft: 'auto' };
            break;
        case 'center':
            commonChildStyle = { marginLeft: 'auto', marginRight: 'auto' };
            break;
    }
    return (React.createElement(Box, { sx: Object.assign(Object.assign({}, props.sx), { display: 'block' }), "data-editor-path": props.childrenEditorPath },
        childProps.length === 0 && (React.createElement(DropTargetSpacerHorizontal, { spacing: props.spacing, first: true, last: true, editorPath: '#0+', placeholderElement: props.editMode ? (React.createElement(DragTargetPlaceholder, null, (_a = props.dragTargetPlaceholderMessage) !== null && _a !== void 0 ? _a : 'Drag and drop components from the toolbar here')) : undefined })),
        childProps.length > 0 &&
            childProps.map((childProp, index) => (React.createElement(React.Fragment, { key: childProp.id },
                React.createElement(DropTargetSpacerHorizontal, { spacing: props.spacing, first: index === 0, last: false, editorPath: '#' + index + '+' }),
                React.createElement(Box, { style: getChildWidgetStyle(childProp, commonChildStyle), "data-editor-path": '#' + index, "data-widget": childProp.dataPath, "data-visible-error": getVisibleError(childProp) ? 'true' : undefined },
                    React.createElement(WidgetComponent, Object.assign({}, childProp, { renderData: props.renderData })))))),
        childProps.length > 0 && (React.createElement(DropTargetSpacerHorizontal, { spacing: props.spacing, first: false, last: true, editorPath: '#' + childProps.length + '+' }))));
};
